import type { ResendInvitation } from '@fourthwall/services/dist/ShopUsersApiClient'
import { ShopUsersApiClient } from '@fourthwall/services/dist/ShopUsersApiClient'
import { useMutation } from '@tanstack/react-query'

export const useResendInvitationMutation = () => {
  const resendInvitationMutation = useMutation({
    mutationFn: async (variables: ResendInvitation['Payload']) => {
      const { data } = await ShopUsersApiClient.resendInvitation(variables)

      return data
    },
  })

  return { resendInvitationMutation }
}
